<template>
  <base-filter-expander
    :title="$t('search.dealer-location')"
    :is-valid="isValid"
    last
  >
    <base-select
      :placeholder="$t('search.select-your-county')"
      class="dealer-location__select"
      :options="counties"
      :multiselect="true"
      :active="selectedCounties"
      :has-nested-options="true"
      @update-store="updateDealerLocations($event)"
    />
  </base-filter-expander>
</template>

<script>
import BaseFilterExpander from "@/components/ui/BaseFilterExpander/BaseFilterExpander.vue";
import BaseSelect from "@/components/ui/BaseSelect/BaseSelect.vue";
import { mapState } from "vuex";
import { UPDATE_DEALERS_LOCATIONS } from "@/store/mutationTypes";
import { GET_DATA_FROM_API } from "@/store/actionTypes";

export default {
  name: "DealerLocationSelect",
  components: {
    BaseFilterExpander,
    BaseSelect
  },
  computed: {
    ...mapState(["search"]),
    isValid() {
      return this.search.dealerLocations.length > 0;
    },
    counties() {
      return this.search.regionsList;
    },
    selectedCounties() {
      return this.search.dealerLocations;
    }
  },
  methods: {
    updateDealerLocations(DealerLocations) {
      this.$store.commit(UPDATE_DEALERS_LOCATIONS, DealerLocations);
      this.$store.dispatch(GET_DATA_FROM_API);
    }
  }
};
</script>

<style lang="scss" scoped>
.dealer-location__select {
  margin-bottom: 30px;
}

@media screen and (min-width: $media-m) {
  .dealer-location__select {
    width: 50%;
    margin: 0 auto 50px;
  }
}

@media screen and (min-width: $media-l) {
  .dealer-location__select {
    width: $select-size-m;
  }
}

@media screen and (min-width: $media-xxl) {
  .dealer-location__select {
    width: $select-size-l;
  }
}
</style>
